import { Fragment } from 'react';

import { Alert, Divider } from 'antd';

import CustomUpload2 from './CustomUpload2';

function Uploader({ items, message }) {
  const view = items?.map((item, index) => (
    <Fragment key={item.key}>
      <CustomUpload2 {...item} />
      {index !== items?.length - 1 && <Divider />}
    </Fragment>
  ));

  return (
    <section>
      {message && <Alert className="mb-30" message={message} type="info" showIcon closable />}
      {view}
    </section>
  );
}

export default Uploader;
